import { createContext } from "react";

const FinancialGroupScreen = createContext<any>(null);

export default FinancialGroupScreen;
